// kagitUcus.js — KÂĞIT OFP UÇUŞU → ARŞİV SATIRI BİÇİMİ: TEK KAYNAK (2 Eki 2026)
//
// 🔑 Serkan (2 Eki 2026): *"paper OFP'ler arşivde görünmüyor"* · arşivde kâğıt uçuşa tıklayınca yan panel
//    açılsın; düzeltme yalnız DUTY HISTORY → EDIT'ten. ARCHIVED sütunu kâğıtta UÇUŞUN BİTİŞİ (on-block) — A:
//    iPad uçuşu inişten hemen sonra arşivlenir, liste uçuş sırasıyla kalsın; ofisin kayıt anı yan panelde.
// STATISTICS bu çeviriyi kendi içinde yapıyordu; ARCHIVED FLTS de okuyunca İKİ kopya olacaktı (İlke 3) — artık
// ikisi de bunu çağırır. Kâğıt satırı arşiv satırıyla AYNI ŞEKİLDE: ekranın geri kalanı ikisini ayırt etmek
// zorunda kalmasın (tek çizim yolu). Sektör başına bir satır (20 Eyl 2026).
import { utcGun } from '../utcTarih';

/** Kâğıt uçuşun ANAHTARI — kayıt, evrak ve klasör aynı anahtarı kullanır (2 Eki 2026, tek kaynak). Atama bağı yoksa
 *  görevin kendi kimliği (yazıcının 7 Eyl'den beri kullandığı kural). */
export const kagitAnahtari = (duty) => duty?.assignment_id || duty?.id || null;

/** Bacak kâğıt OFP bacağı mı: uçuş bacağı (DH değil) ve iPad arşivine bağlı değil (`ucuslar`: plan_id → silinmemiş arşiv
 *  uçuşu). EDIT, kâğıt yazıcısı ve DUTY HISTORY / çizelge AYNI kural (5 Eki 2026 — karışık iPad/kâğıt görev). */
export const kagitBacagiMi = (x, ucuslar = {}) => !!x && !x.deadhead && !(x.plan_id && (ucuslar || {})[String(x.plan_id)]);

/** Görevin kâğıt durumu — DUTY HISTORY tablosu ve aylık çizelge AYNI karar (5 Eki 2026, Serkan B).
 *  `kagit` = { anahtarlar: canlı kâğıt kaydı olan uçuş anahtarları, evrakli: evrakı olanlar, ucuslar: iPad arşivi };
 *  okunamayan küme null gelir → işaret YOK (bilinmiyor ≠ yok). */
export function kagitGorevDurumu(d, kagit) {
  const anahtar = kagitAnahtari(d);
  const kg = !!(kagit?.anahtarlar && d?.duty_type === 'flight' && kagit.anahtarlar.has(anahtar));
  return { kagit: kg, evrakYok: kg && !!kagit.evrakli && !kagit.evrakli.has(anahtar),
           bacak: (s) => kg && kagitBacagiMi(s, kagit.ucuslar) };
}

/** Rozet metinleri — ARCHIVED FLTS, STATISTICS, DUTY HISTORY aynı söz (5 Eki 2026). */
export const PAPER_OFP_IPUCU = 'Flown on a paper OFP — no EFB report exists';
export const NO_DOCS_IPUCU = 'No scanned documents attached — add them in DUTY HISTORY → EDIT';

/** DIVERT = İNİLEN MEYDAN ≠ PLANLANAN VARIŞ — bacak bacak, satırın kendi iki alanından (5 Eki 2026, Serkan: *"planlandığı
 *  gibi biten bir uçuş divert olmaz, olamaz"*). Planlama aşamasındaki değişiklik (rota izi) divert DEĞİLDİR. STATISTICS'in
 *  tek kuralı; kâğıt uçuşta inilen meydan EDIT'teki DIVERT düğmesinden gelir (2. adım). */
export const divertMi = (f) => !!(f?.plans?.dest && f?.destination_icao && f.destination_icao !== f.plans.dest);

/** manual_flights satırı → archived_flights satırının biçimi.
 *  `archived_at` = on-block → off-block → görev günü (saat girilmemiş ESKİ kayıt için; 2 Eki'den beri dört
 *  zaman zorunlu). `kagit` = kâğıt kaydın kendi bilgisi (yan panel). */
export function kagitUcusSatiri(m) {
  return {
    id: `mf-${m.id}`, paperOfp: true, plan_id: null, seq: m.seq ?? null, flt_no: m.flt_no ?? null,
    archived_at: m.on_block || m.off_block || `${m.duty_date}T00:00:00Z`,
    off_blocks: m.off_block ?? null, takeoff_time: m.takeoff_time ?? null,
    landing_time: m.landing_time ?? null, on_blocks: m.on_block ?? null,
    block_minutes: m.block_minutes, airborne_minutes: m.airborne_minutes,
    landing_count: m.landing_count,
    // İniş tipi (22 Eyl 2026): kâğıt uçuşta da elle girilir, aynı kutulara sayılır.
    lnd_type: m.lnd_type ?? null,
    // `null` = ÖLÇÜLEMEDİ, "Day/Night Not Measured" sayacına düşer. Sektör başına satıra geçtikten sonra YENİ
    // yazılan kayıtlarda her bacak kendi ölçümünü taşır; göçten gelen eski bacakların ortası `null` kalır.
    is_night_takeoff: m.is_night_takeoff, is_night_landing: m.is_night_landing,
    departure_icao: m.dep, destination_icao: m.dest,
    // Geçersiz kılınan kâğıt kayıt arşivde DELETED rozetiyle görünür (STATISTICS zaten süzüp okur).
    deleted_at: m.deleted_at ?? null, delete_reason: m.delete_reason ?? null,
    kagit: { kayitId: m.id, atama: m.assignment_id ?? null, kaydeden: m.created_by ?? null,
             kayitAni: m.created_at ?? null, not: m.note ?? null },
    // Planlanan varış: divert'te `planned_dest` (inilen `dest`), yoksa `dest` — `divertMi` ikisini karşılaştırır (5 Eki 2026).
    plans: { customer_id: m.customer_id, dep: m.dep, dest: m.planned_dest || m.dest, reg: m.reg,
             date: m.duty_date ? utcGun(`${m.duty_date}T00:00:00Z`) : null,
             ac_type: null, pf_pilot: m.pf_pilot, pm_pilot: m.pm_pilot, crz_pilot: m.crz_pilot ?? null,
             crz2_pilot: m.crz2_pilot ?? null, trip_fuel: null },   // ikinci CRZ: 4 pilotlu ekip (5 Eki 2026)
  };
}

/** En yeni üstte; aynı ana denk gelen kâğıt bacakları `seq` ile sıralanır. */
export const arsivSirasi = (x, y) =>
  String(y.archived_at || '').localeCompare(String(x.archived_at || '')) || ((x.seq ?? 0) - (y.seq ?? 0));

/** Gün aralığının üst sınırı: `son` günün ERTESİ 00:00 UTC (aralık `bas` dahil, `son` dahil — `lt` ile). */
export const ertesiGunBasi = (son) => new Date(Date.parse(`${son}T00:00:00Z`) + 864e5).toISOString();

/** Kâğıt uçuşun ARCHIVED anı (`kagitUcusSatiri.archived_at`: on-block → off-block → görev günü 00:00 UTC) seçilen gün
 *  aralığında mı — SUNUCU süzgeci olarak (PostgREST `or` ağacı, tek eleman `and(…)`). Aynı kural `arsiv_listesi`
 *  görünümünde (göç 20261006b). STATISTICS tarih aralığı (Serkan A, 6 Eki 2026). `bas` / `son` 'YYYY-MM-DD' (UTC gün,
 *  ikisi de dahil); ikisi de boşsa null. Değerler çift tırnakta — PostgREST'te `.` ve `:` ayrılmış karakterdir. */
export function kagitTarihSuzgeci(bas, son) {
  const t = (v) => `"${v}"`;
  const parca = [];
  if (bas) {
    const a = `${bas}T00:00:00Z`;
    parca.push(`or(on_block.gte.${t(a)},and(on_block.is.null,off_block.gte.${t(a)}),and(on_block.is.null,off_block.is.null,duty_date.gte.${t(bas)}))`);
  }
  if (son) {
    const b = ertesiGunBasi(son);
    parca.push(`or(on_block.lt.${t(b)},and(on_block.is.null,off_block.lt.${t(b)}),and(on_block.is.null,off_block.is.null,duty_date.lte.${t(son)}))`);
  }
  return parca.length ? `and(${parca.join(',')})` : null;
}
